import React from 'react';

import Grid from 'components/Grid';

import InfoItem from './InfoItem';

const EmployeeInfo = ({ employee }) => {
  if (!employee) return null;

  return (
    <Grid gutter={[24, 24]} columns={2}>
      <InfoItem name="ID" value={employee.employee_id} />
      <InfoItem name="Full Name" value={employee.full_name} />
      <InfoItem name="Phone Number" value={employee.phone} />
      <InfoItem name="Location" value={employee.location_name} />
      <InfoItem name="Notes" value={employee.notes} />
    </Grid>
  );
};

export default EmployeeInfo;
